// Theme-aware color values for recharts (which needs concrete color strings,
// not CSS variables). Pass isDark from next-themes resolvedTheme.
export const chartColors = (isDark) => ({
  grid: isDark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.10)",
  tick: isDark ? "rgba(247,247,247,0.55)" : "rgba(15,23,42,0.55)",
  tooltipBg: isDark ? "#0b0b0c" : "#ffffff",
  tooltipBorder: isDark ? "rgba(255,255,255,0.12)" : "rgba(15,23,42,0.12)",
  tooltipLabel: isDark ? "rgba(247,247,247,0.6)" : "rgba(15,23,42,0.6)",
  // Lime brand color for chart strokes/dots. Deepened in light mode so 2px lines
  // and dots stay legible on the white card background.
  lime: isDark ? "#ccff0c" : "#5e7a00",
});
